// extracted by mini-css-extract-plugin
module.exports = {"EmblaSlider":"styles_EmblaSlider__iLbxa","container":"styles_container__mYfqh","hideOverflow":"styles_hideOverflow__OO9KQ","slides":"styles_slides__JOIUz"};